var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.25 8.24994V5.2497C5.25 4.25506 5.64509 3.30116 6.34835 2.59784C7.05161 1.89452 8.00544 1.4994 9 1.4994C9.99456 1.4994 10.9484 1.89452 11.6517 2.59784C12.3549 3.30116 12.75 4.25506 12.75 5.2497V8.24994M3.75 8.24994H14.25C15.0784 8.24994 15.75 8.92157 15.75 9.75006V15.0005C15.75 15.829 15.0784 16.5006 14.25 16.5006H3.75C2.92157 16.5006 2.25 15.829 2.25 15.0005V9.75006C2.25 8.92157 2.92157 8.24994 3.75 8.24994Z",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.848d1f4f7fd967aa18658e8c22534eb3.svg";
export { ForwardRef as ReactComponent };